import { TableBody, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Case } from '../../../../shared/api/hscan/case';
import { genderToString } from '../../../../shared/utils';
import {
  HscanTable,
  HscanTableCell,
} from '../../common/components/SortableTable/Table';

interface PatientInfoTableProps {
  caseInfo: Case;
}
export const PatientInfoTable = (props: PatientInfoTableProps) => {
  const { caseInfo } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.imageDetails.patientInfoTable',
  });
  const { t: globalT } = useTranslation();

  return (
    <HscanTable
      head={
        <TableHead>
          <TableRow>
            <HscanTableCell>{`${t('header.institutionName')}`}</HscanTableCell>
            <HscanTableCell align="center">{`${t(
              'header.patientName',
            )}`}</HscanTableCell>
            <HscanTableCell align="center">{`${t(
              'header.patientSex',
            )}`}</HscanTableCell>
            <HscanTableCell align="center">{`${t(
              'header.birthDate',
            )}`}</HscanTableCell>
          </TableRow>
        </TableHead>
      }
      body={
        <TableBody>
          <TableRow>
            <HscanTableCell>{caseInfo.institutionName}</HscanTableCell>
            <HscanTableCell align="center">
              {caseInfo.patientName}
            </HscanTableCell>
            <HscanTableCell align="center">
              {globalT(`common.gender.${genderToString(caseInfo.patientSex)}`)}
            </HscanTableCell>
            <HscanTableCell align="center">{caseInfo.birthDate}</HscanTableCell>
          </TableRow>
        </TableBody>
      }
    />
  );
};
